import { useQuery } from '@tanstack/react-query';
import { dashboardService } from 'api/services/dashboardService';
import { queryKeys } from 'shared/constants/queryKeys';

export function useDashboardTeamActivity(from: string, to: string, userId?: string) {
  return useQuery({
    queryKey: queryKeys.dashboard.teamActivity(from, to, userId),
    queryFn: async () => {
      const res = await dashboardService.getTeamActivity({ from, to, userId });
      return res.data.data;
    },
    staleTime: 5 * 60 * 1000,
    enabled: Boolean(from && to),
  });
}
